export default __webpack_public_path__ + "529c16481d1dc2cade4c36f83c16e28a.svg";